import React from 'react'
import PropTypes from 'prop-types'
import { CImage } from '@coreui/react'

const PartnerInfoRow = ({
  icon = null,
  picture = '',
  title,
  badge = null,
  lines = [],
  imageWidth = 56,
  iconClassName = '',
}) => {
  return (
    <div className="d-flex align-items-start gap-3 flex-grow-1 flex-wrap">
      {icon}
      {picture ? (
        <CImage
          src={picture}
          alt={title}
          className="rounded flex-shrink-0"
          width={imageWidth}
          style={{ height: 'auto', objectFit: 'contain' }}
        />
      ) : null}
      <div className="d-flex flex-column gap-1 flex-grow-1">
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <strong>{title}</strong>
          {badge}
        </div>
        {lines.filter(Boolean).map((line, index) => (
          <span key={`${title}-detail-${index}`} className="text-medium-emphasis small">
            {line}
          </span>
        ))}
      </div>
    </div>
  )
}

PartnerInfoRow.propTypes = {
  icon: PropTypes.node,
  picture: PropTypes.string,
  title: PropTypes.string.isRequired,
  badge: PropTypes.node,
  lines: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.node])),
  imageWidth: PropTypes.number,
  iconClassName: PropTypes.string,
}

export default PartnerInfoRow
